import axios from 'axios'
import {utils} from "../utils"
import md5 from "js-md5"
import {app} from "./app"
import {baseConfig} from "../baseConfig";

//当返回这两个错误码时需要重新获取token
//验证授权失败 被强制下线
const ACCOUNT_NO_LOGIN = 10005;
//登录过期
const LOGOUT_EXPIRE = 11010;

// 请求令牌
function AppAuthToken() {
  // this.appAuthToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjY5LCJpc3MiOiJodHRwOi8vMTIwLjc4LjAuMTY3L3BvcHVsYXJpemF0aW9uL2FwaS90b29kbyIsImlhdCI6MTY0ODc3NDIwOCwiZXhwIjoxNjQ4Nzg1MDA4LCJuYmYiOjE2NDg3NzQyMDgsImp0aSI6InAzODBZZ3I5TWd1TGVjeTYifQ.95AccA-dy8WEH0o2fUH7BqINnBYj8FaZMwHgXkJ0-sY'
  //this.appAuthToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjU5LCJpc3MiOiJodHRwOi8vMTIwLjc4LjAuMTY3L3BvcHVsYXJpemF0aW9uL2FwaS90b29kbyIsImlhdCI6MTY0ODE4NjYzOSwiZXhwIjoxNjQ4MTk3NDM5LCJuYmYiOjE2NDgxODY2MzksImp0aSI6Ik5ESW9yMkFKZVEzYjNoVXIifQ.muu7UjAfebxR114T478smNKGxQd7giLRq1JcFo9uoXE'
  this.get = function () {
    if (this.appAuthToken) return this.appAuthToken;
    return this.request()
  };
  this.clear = function () {
    this.appAuthToken = '';
  };
  this.request = function (refresh = false) {
    const timestamp = Math.floor(new Date().getTime() / 1000);
    const appID = baseConfig.wechatAPIConfig.APP_ID();
    const appSecret = baseConfig.wechatAPIConfig.SECRET()
    const sign = md5(`${appID}${timestamp}${appSecret}`);
    this.appAuthToken = app.getToken(timestamp, sign, refresh);
    // alert("refresh:"+refresh+this.appAuthToken)
    return this.appAuthToken
  };
  this.requestWX = function () {
    app.getTokenWX();
  };
  this.refresh = function (token) {
    this.appAuthToken = token;
    app.refreshToken(token)
  }
}

const appAuthToken = new AppAuthToken();

function RequestBody(method, bizContent) {
  this.appId = baseConfig.wechatAPIConfig.APP_ID();
  this.method = method;
  this.format = 'JSON';
  this.charset = 'utf-8';
  this.signCode = '';
  this.timestamp = utils.toDate();
  this.version = '1.0';
  this.appAuthToken = '';
  this.bizContent = bizContent;
  this.encrypt = function () {
    let keys = Object.keys(this).sort();
    let signCode = '';
    keys.forEach(key => {
      if (key !== 'encrypt') signCode += this[key]
    });
    signCode += baseConfig.wechatAPIConfig.SECRET();
    this.signCode = md5(signCode);
  }
}

/**
 * 响应体
 * @constructor
 */
function ResponseBody() {
  this.code = "";
  this.subCode = "";
  this.msg = "";
  this.subMsg = "";
  this.timestamp = "";
  this.sign = "";
  this.bizContent = "";
  this.token = "";
  this.check = function () {
    if (this.code !== 0) {
      if (this.code === ACCOUNT_NO_LOGIN) {
        // alert("token ACCOUNT_NO_LOGIN");
        //发送一条总线命令，让其通知想知道的组件
        appAuthToken.request(true)
        // appAuthToken.request(false)
        appAuthToken.clear()
        // alert("token ACCOUNT_NO_LOGIN:"+appAuthToken.get());
        appAuthToken.requestWX()
      }else if(this.code === LOGOUT_EXPIRE){
        // alert("token LOGOUT_EXPIRE");
        appAuthToken.request(true)
        // appAuthToken.request(false)
        appAuthToken.clear()
      }

      throw {code: this.code, msg: this.msg};
    }
    let keys = Object.keys(this).sort();
    let signCode = '';
    keys.forEach(key => {
      if (
          key !== 'fillBody' &&
          key !== 'getData' &&
          key !== 'check' &&
          key !== 'sign'
      ) signCode += this[key]
    });
    signCode += baseConfig.wechatAPIConfig.SECRET();
    if (md5(signCode) !== this.sign) {
      throw {code: -1, msg: '签名错误'};
    }

    // 判断token是否需要更新
    if (this.token && appAuthToken.appAuthToken !== this.token) {
      appAuthToken.refresh(this.token)
    }
  };
  this.getData = function () {
    return JSON.parse(this.bizContent)
  }
}

// `transformRequest` 允许在向服务器发送前，修改请求数据
function actTransformRequest(data, headers) {
  if (typeof (data.bizContent) === 'object') data.bizContent = JSON.stringify(data.bizContent);
  const requestBody = new RequestBody(data.method, data.bizContent);
  requestBody.encrypt();
  // console.log(JSON.stringify(requestBody))
  return JSON.stringify(requestBody)
}

// `transformResponse` 在传递给 then/catch 前，允许修改响应数据
function actTransformResponse(data) {
  // 当接口返回新的token时需要将token回传给app
  const responseBody = new ResponseBody();
  utils.fillData(JSON.parse(data), responseBody);
  responseBody.check();
  return responseBody.getData()
}

function request(config) {
  const instance = axios.create({
    baseURL: baseConfig.getWechatAPIBaseUrl(),
    method: "POST",
    timeout: 30000,
    headers: {'Content-Type': 'application/json'},
    transformRequest: actTransformRequest,
    transformResponse: actTransformResponse
  })

  //请求拦截
  instance.interceptors.request.use(config=>{
    // console.log('interceptors request----ok');
    // console.log(config)
    return config
  }, err=>{
    console.log('interceptors request----err');
    console.log(err);
    throw err;
  })
  //响应拦截
  instance.interceptors.response.use(res=>{
      // console.log('interceptors response----ok');
      // console.log(res);
      return res.data
    }, err=>{
      console.log('interceptors response----err');
      console.log(JSON.stringify(err));
      throw err;
    }
  )
  return instance(config)
}

function getToken(){
  return appAuthToken.get()
}

function refreshToken(token){
  return appAuthToken.refresh(token)
}

export const requestWechat = {
  request,
  getToken,
  refreshToken,
}